import { PRODUCT_BROADBAND } from '@/constants/products';
import { getRateChanges } from '@/graphql/queries/shared/rate-change';
import lang from '@/lang/middleware/products/broadband';

export default async ({ $apolloQuery, store }) => {
  await $apolloQuery(getRateChanges, { product: PRODUCT_BROADBAND }).then(rateChangeSet => {
    store.$i18n.mergeLocaleMessage('en', lang.en);
    const description = store.$i18n.t('price-changes.description');
    const subtitle = store.$i18n.t('price-changes.subtitle');
    const title = store.$i18n.t('price-changes.title');
    store.commit('jumbotron/SET_JUMBOTRON', { subtitle, title, type: 'generic' });
    store.commit('pageContent/setHead', { description, title });
    store.commit('rateChanges/setMeta', rateChangeSet.data);
    store.commit('rateChanges/set', rateChangeSet.changes);
    store.commit('utils/setPagination', rateChangeSet.meta.pagination);
  });
};
